import './i18n';
import SwitchRouter from '@/router/index'
import RouterConfig from '@/router/config'
import '@/App.less';
import Header from '@/pages/components/layout/Header'
import Footer from '@/pages/components/layout/Footer'
import { HashRouter as Router } from 'react-router-dom'

function App (props) {
  return (
    <Router>
      <Header />
      <SwitchRouter routes={RouterConfig} />
      <Footer />
    </Router>
  );
}

export default App;
